/**
 * Format a string to be URL safe
 * @param {String} str 
 * @returns 
 */
export default function formatUrlSafe(str) {
    return str
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "")
}
